import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { HubIcon } from "../HubIcon";
import { PRIORITY_TYPES } from "../../constants/priority";

export const PriorityLabel = ({
  priority,
  label,
  icon,
  color,
  iconOnly = false,
}) => {
  const val =
    PRIORITY_TYPES.find(({ id }) => id === priority) || PRIORITY_TYPES[3];

  return (
    <Stack direction="row" gap="10px" alignItems="center">
      <HubIcon
        icon={icon || val.icon}
        sx={{ color: color || val.color, strokeWidth: "1.5px" }}
        size="16px"
      />
      {/* <Box
        sx={{
          width: "10px",
          height: "10px",
          backgroundColor: color || val.color,
          borderRadius: "2px",
        }}
      /> */}
      {!iconOnly && (
        <Typography sx={{ fontSize: "12px !important" }}>
          {label || val.label}
        </Typography>
      )}
    </Stack>
  );
};

export default PriorityLabel;
